import _toConsumableArray from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
import { image, serialization, tidy } from '@tensorflow/tfjs-core'; // mul, add
import { Layer } from '../../engine/topology';
import { ValueError } from '../../errors';
import { getExactlyOneShape } from '../../utils/types_utils'; //, getExactlyOneTensor
// tf methods unimplemented in tfjs: 'bicubic', 'area', 'lanczos3', 'lanczos5',
//                                   'gaussian', 'mitchellcubic'
var INTERPOLATION_KEYS = ['bilinear', 'nearest'];
var INTERPOLATION_METHODS = new Set(INTERPOLATION_KEYS);
/**
 * Preprocessing Resizing Layer
 *
 * This resizes images by a scaling and offset factor
 */
var Resizing = /*#__PURE__*/function (_Layer) {
  _inherits(Resizing, _Layer);
  function Resizing(args) {
    var _this;
    _classCallCheck(this, Resizing);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Resizing).call(this, args));
    _this.height = args.height;
    _this.width = args.width;
    if (args.interpolation) {
      if (INTERPOLATION_METHODS.has(args.interpolation)) {
        _this.interpolation = args.interpolation;
      } else {
        throw new ValueError("Invalid interpolation parameter: ".concat(args.interpolation, " is not implemented"));
      }
    } else {
      _this.interpolation = 'bilinear';
    }
    _this.cropToAspectRatio = Boolean(args.cropToAspectRatio);
    return _this;
  }
  _createClass(Resizing, [{
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      inputShape = getExactlyOneShape(inputShape);
      var numChannels = inputShape[2];
      return [this.height, this.width, numChannels];
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var config = {
        'height': this.height,
        'width': this.width,
        'interpolation': this.interpolation,
        'cropToAspectRatio': this.cropToAspectRatio
      };
      var baseConfig = _get(_getPrototypeOf(Resizing.prototype), "getConfig", this).call(this);
      Object.assign(config, baseConfig);
      return config;
    }
  }, {
    key: "call",
    value: function call(inputs, kwargs) {
      var _this2 = this;
      return tidy(function () {
        var size = [_this2.height, _this2.width];
        if (_this2.interpolation === 'bilinear') {
          return image.resizeBilinear(inputs, size, !_this2.cropToAspectRatio);
        } else if (_this2.interpolation === 'nearest') {
          return image.resizeNearestNeighbor(inputs, size, !_this2.cropToAspectRatio);
        } else {
          throw new Error("Interpolation is ".concat(_this2.interpolation, " but only ").concat(_toConsumableArray(INTERPOLATION_METHODS), " are supported"));
        }
      });
    }
  }]);
  return Resizing;
}(Layer);
/** @nocollapse */
Resizing.className = 'Resizing';
export { Resizing };
serialization.registerClass(Resizing);